// Imports
import Events from '@utilities/events';

/**
 * GTM envent on footer subscribe button (newsletter_footer)
 * @param {Boolean} subscribe - true if it is a subscription action / false if it is opening a subscription form
 *
 * @return {Void}
 */
const gtmFooterSubscribeButtonClick = function(subscribe, userData) {
  if (subscribe) {
    const newsletterSubscriptionForm = document.querySelector('.newsletter-subscription-form__form');

    if (newsletterSubscriptionForm) {
      let userType = newsletterSubscriptionForm.querySelector('input[name="dwfrm_newsletter_accountType"]:checked')
        ? newsletterSubscriptionForm.querySelector('input[name="dwfrm_newsletter_accountType"]:checked').value
        : null;

      // data normalization
      userType = userType === 'private' ? 'consumer' : userType;

      const dataToPush = {
        event: 'newsletter',
        action: 'subscribe',
        user_type: userType
      };

      if (userData) {
        dataToPush.user_data = userData;
      }

      Events.$trigger('gtm::push', {
        data: dataToPush
      });
    }
  } else {
    const subscribeButton = document.querySelector('[js-hook-newsletter-button-gtm]');

    if (subscribeButton) {
      subscribeButton.addEventListener('click', () => {
        Events.$trigger('gtm::push', {
          data: {
            event: 'newsletter',
            action: 'click'
          }
        });
      });
    }
  }
};

export default gtmFooterSubscribeButtonClick;
